import { render, staticRenderFns } from "./BotaoRemoverItemAditivoApostila.vue?vue&type=template&id=7c6ba59e"
import script from "./BotaoRemoverItemAditivoApostila.vue?vue&type=script&lang=js"
export * from "./BotaoRemoverItemAditivoApostila.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports